import React, { useState } from "react";
import { X, Send, ClipboardList, Info, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import axios from "axios";
import { toast } from "sonner";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export const ListRequestModal = ({ seller, onClose }) => {
    const [step, setStep] = useState(1); // 1: form, 2: success
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        buyer_name: localStorage.getItem("buyer_name") || "",
        buyer_phone: localStorage.getItem("buyer_phone") || "",
    });
    const [items, setItems] = useState([""]); // Start with one empty item

    const addItem = () => setItems([...items, ""]);
    const removeItem = (index) => {
        if (items.length > 1) {
            const newItems = items.filter((_, i) => i !== index);
            setItems(newItems);
        } else {
            setItems([""]);
        }
    };
    const updateItem = (index, value) => {
        const newItems = [...items];
        newItems[index] = value;
        setItems(newItems);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validItems = items.filter(it => it.trim() !== "");
        if (validItems.length === 0) {
            toast.error("Tanpri ajoute omwen yon atik nan lis la.");
            return;
        }

        setLoading(true);
        try {
            const buyer_id = localStorage.getItem("buyer_id");
            await axios.post(`${API}/marketplace/list-requests`, {
                seller_id: seller.id,
                buyer_name: formData.buyer_name,
                buyer_phone: formData.buyer_phone,
                items_text: validItems.join("\n"),
                items: validItems.map(name => ({ name, price_htg: 0, quantity: 1 })),
                buyer_id: buyer_id
            });
            setStep(2);
        } catch (error) {
            console.error("Error submitting list:", error);
            toast.error("Yon erè fèt pandan n ap voye lis la. Tanpri eseye ankò.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-xl z-[100] flex items-center justify-center p-2 sm:p-4 animate-in fade-in duration-300">
            <div className="w-full max-w-2xl relative max-h-[95vh] flex flex-col">
                <Card className="border-none shadow-2xl rounded-[30px] sm:rounded-[40px] overflow-hidden bg-white flex flex-col">
                    <div className="overflow-y-auto flex-1 custom-scrollbar">
                        {step === 1 ? (
                            <>
                                <div className="bg-[#232F3E] p-6 sm:p-8 text-white relative overflow-hidden">
                                    <Button 
                                        variant="ghost" 
                                        size="icon" 
                                        onClick={onClose}
                                        className="absolute top-4 right-4 sm:top-6 sm:right-6 text-white/50 hover:text-white hover:bg-white/10 rounded-full z-20"
                                    >
                                        <X className="w-5 h-5 sm:w-6 sm:h-6" />
                                    </Button>
                                    <div className="absolute top-0 left-0 w-32 h-32 bg-[#FF9900]/10 rounded-full blur-3xl -translate-x-12 -translate-y-12"></div>
                                    <div className="relative z-10 flex flex-col items-center">
                                        <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#FF9900] rounded-2xl flex items-center justify-center shadow-xl mb-3 sm:mb-4 transform -rotate-6">
                                            <ClipboardList className="w-7 h-7 sm:w-10 sm:h-10 text-black" />
                                        </div>
                                        <h2 className="text-2xl sm:text-3xl font-black italic tracking-tighter uppercase leading-tight text-center">
                                            Kreye Lis <br /> <span className="text-[#FF9900]">Atik Ou Yo</span>
                                        </h2>
                                        <p className="text-gray-400 font-bold text-[10px] sm:text-xs uppercase tracking-widest mt-2 text-center">Voye lis ba: {seller?.store_name || seller?.fullname}</p>
                                    </div>
                                </div>

                                <CardContent className="p-5 sm:p-8">
                                    <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <div className="space-y-1.5">
                                                <label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 px-1">Non Ou</label>
                                                <input 
                                                    type="text"
                                                    required
                                                    value={formData.buyer_name}
                                                    onChange={(e) => setFormData({...formData, buyer_name: e.target.value})}
                                                    placeholder="Non konplè"
                                                    className="w-full h-12 sm:h-14 bg-gray-50 border-gray-100 rounded-xl sm:rounded-2xl px-5 font-bold focus:ring-2 focus:ring-[#FF9900] transition-all"
                                                />
                                            </div>
                                            <div className="space-y-1.5">
                                                <label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 px-1">Telefòn Ou</label>
                                                <input 
                                                    type="tel"
                                                    required
                                                    value={formData.buyer_phone}
                                                    onChange={(e) => setFormData({...formData, buyer_phone: e.target.value})}
                                                    placeholder="Nimewo Telefòn"
                                                    className="w-full h-12 sm:h-14 bg-gray-50 border-gray-100 rounded-xl sm:rounded-2xl px-5 font-bold focus:ring-2 focus:ring-[#FF9900] transition-all"
                                                />
                                            </div>
                                        </div>

                                        <div className="space-y-3">
                                            <label className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400 px-1">Ki Atik Ou Bezwen?</label>
                                            
                                            <div className="space-y-3 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar">
                                                {items.map((item, index) => (
                                                    <div key={index} className="flex gap-2 animate-in slide-in-from-left-2 duration-300" style={{ animationDelay: `${index * 50}ms` }}>
                                                        <div className="flex-1 relative group">
                                                            <input 
                                                                type="text"
                                                                required={index === 0}
                                                                value={item}
                                                                onChange={(e) => updateItem(index, e.target.value)}
                                                                placeholder={`Egz: ${index === 0 ? '2 Sak diri Mega' : 'Lòt atik...'}`}
                                                                className="w-full h-12 sm:h-14 bg-gray-50/50 border border-gray-100 hover:border-[#FF9900]/30 rounded-xl sm:rounded-2xl px-5 pr-10 font-bold focus:ring-2 focus:ring-[#FF9900] transition-all outline-none"
                                                            />
                                                            {items.length > 1 && (
                                                                <button 
                                                                    type="button"
                                                                    onClick={() => removeItem(index)}
                                                                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-300 hover:text-red-500 transition-colors"
                                                                >
                                                                    <X className="w-4 h-4" />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            <Button 
                                                type="button" 
                                                onClick={addItem}
                                                variant="outline"
                                                className="w-full h-12 border-2 border-dashed border-gray-200 rounded-xl sm:rounded-2xl text-gray-400 hover:text-[#FF9900] hover:border-[#FF9900] hover:bg-orange-50 font-black uppercase text-[10px] tracking-widest transition-all"
                                            >
                                                + Ajoute Yon Lòt Atik
                                            </Button>
                                        </div>

                                        <div className="bg-amber-50 rounded-xl sm:rounded-2xl p-3 sm:p-4 flex gap-3 border border-amber-100">
                                            <Info className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
                                            <p className="text-[10px] sm:text-[11px] text-amber-900 font-bold leading-relaxed italic uppercase">
                                                Machann nan pral resevwa lis sa a, verifye sa l genyen, epi reponn ou ak pri chak atik yo.
                                            </p>
                                        </div>

                                        <Button 
                                            type="submit"
                                            disabled={loading}
                                            className="w-full h-14 sm:h-16 bg-[#FF9900] hover:bg-[#E88B00] text-black rounded-xl sm:rounded-2xl font-black text-base sm:text-lg tracking-widest uppercase shadow-xl shadow-orange-500/20 flex gap-4 disabled:opacity-50"
                                        >
                                            {loading ? <div className="loading-spinner scale-50"></div> : <Send className="w-5 h-5 sm:w-6 sm:h-6" />}
                                            {loading ? "Voye an kous..." : "Voye Lis la"}
                                        </Button>
                                    </form>
                                </CardContent>
                            </>
                        ) : (
                            <div className="p-8 sm:p-12 text-center relative space-y-6 sm:space-y-8 animate-in zoom-in duration-500">
                                <Button 
                                    variant="ghost" 
                                    size="icon" 
                                    onClick={onClose}
                                    className="absolute top-4 right-4 sm:top-6 sm:right-6 text-gray-300 hover:text-black hover:bg-gray-100 rounded-full z-20"
                                >
                                    <X className="w-5 h-5 sm:w-6 sm:h-6" />
                                </Button>
                                <div className="w-20 h-20 sm:w-24 sm:h-24 bg-green-500 rounded-[30px] sm:rounded-[35px] flex items-center justify-center mx-auto shadow-2xl shadow-green-200 animate-bounce">
                                    <CheckCircle2 className="w-10 h-10 sm:w-14 sm:h-14 text-white" />
                                </div>
                                <div className="space-y-2">
                                    <h3 className="text-2xl sm:text-3xl font-black italic tracking-tighter uppercase text-gray-900">Vwayaj Reyisi! 🚀</h3>
                                    <p className="text-sm sm:text-base text-gray-500 font-bold leading-relaxed px-4 sm:px-8">
                                        Lis ou an voye bay **{seller?.store_name}** avèk siksè. 👋 <br className="hidden sm:block" />
                                        Depi machann nan fin mete pri yo, w ap resevwa yon notifikasyon pou w ka peye.
                                    </p>
                                </div>
                                <Button 
                                    onClick={onClose}
                                    className="h-12 sm:h-14 px-8 sm:px-12 bg-[#232F3E] hover:bg-black text-white rounded-xl sm:rounded-2xl font-black uppercase tracking-widest shadow-xl text-sm sm:text-base"
                                >
                                    Oke, Mèsi
                                </Button>
                            </div>
                        )}
                    </div>
                </Card>
            </div>
        </div>
    );
};
